var _rect, _rect2, _rect3, _line, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 21.5,
    rx: 0.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 21.5,
    rx: 0.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 21.5,
    height: 21.5,
    rx: 0.75,
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.64999,
    x2: 4.64999,
    y2: 22,
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0569 11.2015C16.168 11.1195 16.1916 10.963 16.1096 10.8519C16.0276 10.7408 15.8711 10.7173 15.76 10.7992L16.0569 11.2015ZM10.2669 15.1641L10.4154 15.3652L16.0569 11.2015L15.9085 11.0004L15.76 10.7992L10.1185 14.9629L10.2669 15.1641Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7527 11.1945C15.8605 11.2808 16.0178 11.2633 16.1041 11.1555C16.1903 11.0476 16.1728 10.8903 16.065 10.8041L15.7527 11.1945ZM10.4087 6.59961L10.2526 6.79483L15.7527 11.1945L15.9088 10.9993L16.065 10.8041L10.5649 6.40439L10.4087 6.59961Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarright);
export default __webpack_public_path__ + "static/media/sidebarright.c6a4c9a21a1a71511168c30150dfb610.svg";
export { ForwardRef as ReactComponent };